import { Placeholder } from 'react-bootstrap'
import React from 'react'
import { SmallLoadingPlaceholder } from './SmallLoadingPlaceholder'

export const TableLoadingPlaceholder = () => {
  return (
    <>
      <tr>
        <td colSpan={10}>
          <Placeholder animation="glow">
            <Placeholder md={8} />
            <Placeholder md={7} bg="primary" />
            <Placeholder md={12} size="xs" />
          </Placeholder>
        </td>
      </tr>
      <tr>
        <td colSpan={3}>
          <Placeholder animation="glow">
            <Placeholder md={8} />
            <Placeholder md={7} bg="primary" />
            <Placeholder md={12} size="xs" />
          </Placeholder>
        </td>
      </tr>
    </>
  )
}

export const FullTableLoadingPlaceholder = () => {
  return (
    <div>
      <table className="table table-striped table-bordered">
        <tbody>
          <tr>
            <td>
              <SmallLoadingPlaceholder />
            </td>
            <td>
              <SmallLoadingPlaceholder />
            </td>
            <td>
              <SmallLoadingPlaceholder />
            </td>
          </tr>
          <tr>
            <td>
              <Placeholder animation="glow">
                <Placeholder md={7} size="xs" />
              </Placeholder>
            </td>
            <td>
              <Placeholder animation="glow">
                <Placeholder md={10} size="xs" />
              </Placeholder>
            </td>
            <td>
              <Placeholder animation="glow">
                <Placeholder md={12} size="xs" />
              </Placeholder>
            </td>
          </tr>
          <tr>
            <td>
              <Placeholder animation="glow">
                <Placeholder md={7} size="xs" />
              </Placeholder>
            </td>
            <td>
              <Placeholder animation="glow">
                <Placeholder md={10} size="xs" />
              </Placeholder>
            </td>
            <td>
              <Placeholder animation="glow">
                <Placeholder md={12} size="xs" />
              </Placeholder>
            </td>
          </tr>
          <tr>
            <td>
              <Placeholder animation="glow">
                <Placeholder md={7} size="xs" />
              </Placeholder>
            </td>
            <td>
              <Placeholder animation="glow">
                <Placeholder md={10} size="xs" />
              </Placeholder>
            </td>
            <td>
              <Placeholder animation="glow">
                <Placeholder md={12} size="xs" />
              </Placeholder>
            </td>
          </tr>
          <tr>
            <td>
              <SmallLoadingPlaceholder />
            </td>
            <td>
              <SmallLoadingPlaceholder />
            </td>
            <td>
              <SmallLoadingPlaceholder />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}
